import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App.js';
import { WorkspaceProvider } from './ui/state.js';
import './styles/tokens.css';
import './styles/base.css';
import './styles/screens.css';
import './styles/print.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WorkspaceProvider>
      <App />
    </WorkspaceProvider>
  </StrictMode>,
);
